function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

module.exports = _taggedTemplateLiteral;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/taggedTemplateLiteral.js
// module id = 453
// module chunks = 0